import React from "react";
import { CheckCircle2 } from "lucide-react";

const ABOUT_IMG =
  "https://customer-assets.emergentagent.com/job_maritime-solutions-10/artifacts/8ml0pde4_polish_save.png";

const PILLARS = [
  "Avitaillement de navires en vivres et matériels",
  "Achat, vente et livraison de produits vivriers",
  "Import-Export et logistique internationale",
  "Approvisionnement maritime professionnel",
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="bg-white py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <div className="relative">
            <img
              src={ABOUT_IMG}
              alt="Bureau corporate maritime KMS"
              className="w-full h-[480px] object-cover"
            />
            <div className="absolute -bottom-6 -right-6 bg-[#0A1128] text-white p-6 max-w-[240px] hidden md:block">
              <div className="text-xs uppercase tracking-[0.25em] text-[#D90429] mb-2">
                Depuis 2025
              </div>
              <div className="font-heading font-bold text-lg leading-tight">
                Société agréée en Côte d'Ivoire
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <div className="kms-overline mb-4 flex items-center gap-4">
            <span className="font-heading font-black text-sm text-[#D90429]">01</span>
            <span className="h-px w-12 bg-[#D90429]" />
            <span>À propos de nous</span>
          </div>
          <h2 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl tracking-tighter text-[#0A1128] leading-[1.05]">
            Un partenaire <span className="text-[#D90429]">maritime</span> de
            confiance.
          </h2>

          <p className="mt-6 text-base sm:text-lg leading-relaxed text-[#374151]">
            <strong className="font-bold text-[#0A1128]">
              KMS SERVICES PLUS (KMS SP SARL)
            </strong>{" "}
            est une société spécialisée dans l'avitaillement maritime, l'achat
            et la vente de produits vivriers, la livraison de produits, le
            commerce de matériels et équipements, l'import-export ainsi que les
            services liés à l'approvisionnement maritime.
          </p>

          <p className="mt-4 text-base leading-relaxed text-[#6B7280]">
            Nous accompagnons les navires, entreprises et partenaires
            commerciaux avec des solutions fiables, rapides et professionnelles.
          </p>

          <ul className="mt-8 space-y-3">
            {PILLARS.map((p) => (
              <li key={p} className="flex items-start gap-3">
                <CheckCircle2
                  className="text-[#D90429] flex-shrink-0 mt-1"
                  size={20}
                />
                <span className="text-[#1F2937] font-medium">{p}</span>
              </li>
            ))}
          </ul>

          <div className="mt-10 flex flex-wrap gap-8 border-t border-gray-200 pt-8">
            <div>
              <div className="font-heading font-black text-3xl text-[#0A1128]">
                3M
              </div>
              <div className="text-xs uppercase tracking-widest text-[#9CA3AF] mt-1">
                FCFA · Capital
              </div>
            </div>
            <div>
              <div className="font-heading font-black text-3xl text-[#0A1128]">
                ABJ
              </div>
              <div className="text-xs uppercase tracking-widest text-[#9CA3AF] mt-1">
                Treichville · CI
              </div>
            </div>
            <div>
              <div className="font-heading font-black text-3xl text-[#0A1128]">
                2025
              </div>
              <div className="text-xs uppercase tracking-widest text-[#9CA3AF] mt-1">
                Registre commerce
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
